<template>
  <table id="activeTable" class="upcoming-table small-table-text">
    <thead>
      <tr id="activeTable-header-row">
        <th style="width: 5%"></th>
        <th style="width: 5%">Time</th>
        <th style="width: 40%">Pickup</th>
        <th style="width: 3%">Vias</th>
        <th style="width: 40%">Destination(s)</th>
        <th style="width: 2%">Price</th>
      </tr>
    </thead>
    <tr v-for="booking in bookingForm.user.booked_bookings" valign="top">
      <td>
        <a @click="rebook(booking)">
          <b>RBK</b>
        </a>
      </td>
      <td>{{(booking.pickup_time)}}</td>
      <td>{{(booking.pickup_location.description.substring(0, 40))}}</td>
      <td>
        <ViasForBooking :booking="booking" />
      </td>
      <td v-html="destinationsForItem(booking)"></td>
      <td>£{{(booking.final_cost / 100).toFixed(2)}}</td>
      <td v-if="allowView">
        <a target="_blank" :href="'/bookings?bookingID=' + booking.id">View</a>
      </td>
    </tr>
  </table>
</template>

<script>
import moment from "moment";

import { Overwatch } from "@/components/util/Overwatch.js";

import ViasForBooking from "@/components/overwatch/ViasForBooking.vue";

export default {
  name: "user_recent_bookings",
  components: {
    ViasForBooking
  },
  props: {
    bookingForm: Object,
    rebook: Function,
    allowRebook: {
      type: Boolean,
      default: true
    },
    allowView: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    destinationsForItem: function(booking) {
      var destinations = "-";

      if (booking.destinations.length > 0) {
        destinations = "<ul>";
        // // Convert to order VIA, VIA, DESTINATION
        // //for ( var j in destinations ) {
        // for (var i = 1; i < 1; i++) {
        //   destinations +=
        //     "<li> <i>Via " +
        //     i +
        //     "</i> - " +
        //     booking.destinations[i].description +
        //     "</li>";
        // }
        destinations +=
          "<li>" +
          booking.destinations[0].description.substring(0, 40) +
          "</li>";
        destinations += "</ul>";
      }

      return destinations;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#gridcontainer {
  position: absolute;
  top: 0;
  bottom: 24px;
  left: 0;
  right: 0;
  overflow: auto;
}

#searchcontainer {
  position: absolute;
  width: 100%;
  height: 24px;
  bottom: 0px;
  left: 0;
  padding-top: 1px;
  padding-left: 24px;
  right: 0;
  background-color: #f5f5f5;
}

.upcoming-table {
  font-size: 11px;
}

th {
  text-align: left;
  color: #10425a;
}

th,
td {
  text-align: left;
  padding-left: 8px;
}

td {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

table {
  padding: 4px;
  border-collapse: collapse;
}

ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  color: #10425a;
}

.small-text {
  font-size: 13px;
}
</style>
